import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import Spinner from '../../platformui/Spinner';
import StatusList from './statuslist';
import { IDSExpandableAlert } from './ids-expandable-alert';
import ErrorAlert from './iconsTemporary/errorAlert';
import AttentionAlert from './iconsTemporary/attentionAlert';
import SuccessAlert from './iconsTemporary/successAlert';
import InfoAlert from './iconsTemporary/infoAlert';

const ServiceInfo = (props) => {
  if (typeof window === 'undefined') return null;

  const [isLoading, setIsLoading] = useState(false);
  const allparentRefErrror = [];
  const allparentRefWarning = [];

  const [openedErrorExpandable, setOpenedErrorExpandable] = useState(() => {
    const saved = sessionStorage.getItem('openedErrorExpandables');
    return saved ? JSON.parse(saved) : {};
  });
  const [openedWarningExpandable, setOpenedWarningExpandable] = useState(() => {
    const saved = sessionStorage.getItem('openedWarningExpandables');
    return saved ? JSON.parse(saved) : {};
  });

  const [statuses, setStatuses] = useState(
    sessionStorage.getItem('serviceStatus')
      ? JSON.parse(sessionStorage.getItem('serviceStatus')).AllStatuses
      : []
  );
  let allStatuses = sessionStorage.getItem('serviceStatus')
    ? JSON.parse(sessionStorage.getItem('serviceStatus')).AllStatuses
    : [];

  const [errorStatuses, setErrorStatuses] = useState(
    sessionStorage.getItem('serviceStatus')
      ? JSON.parse(sessionStorage.getItem('serviceStatus')).ErrorStatuses
      : []
  );

  const [warningStatuses, setWarningStatuses] = useState(
    sessionStorage.getItem('serviceStatus')
      ? JSON.parse(sessionStorage.getItem('serviceStatus')).WarningStatuses
      : []
  );

  let serviceMessages = props.ServiceMessages ? props.ServiceMessages : [];

  let { Translations } = props;

  const getServiceNowOperationalStatus = async (update) => {
    if (!update) {
      if (isLoading) return false;
      setIsLoading(true);
    }

    let eTagLS =
      typeof sessionStorage.getItem('ETag') !== 'undefined'
        ? sessionStorage.getItem('ETag')
        : null;

    let options = {
      headers: {
        'Content-Type': 'application/json',
        'If-None-Match': eTagLS,
      },
    };

    const url = props.ServiceInfoApiUrl;

    await fetch('/' + url, options)
      .then((res) => {
        if (update) {
          console.log(
            new Date().toLocaleTimeString().slice(0, 5) + ': updating data',
            res.statusText
          );
        }
        if (isLoading || res.status === 304) return null;
        if (update) {
          setIsLoading(true);
        }
        let fetchedTag = res.headers.get('ETag');

        if (eTagLS === null || eTagLS !== fetchedTag) {
          sessionStorage.setItem('ETag', fetchedTag);
          return res.json();
        }
        return null;
      })
      .then((serviceStatus) => {
        if (serviceStatus) {
          if (!update) {
            console.log(
              new Date().toLocaleTimeString().slice(0, 5) +
                ': Fetching new data'
            );
          }
          sessionStorage.setItem(
            'serviceStatus',
            JSON.stringify(serviceStatus)
          );
          setStatuses(serviceStatus);
        }
      })
      .catch((err) => {
        console.log(err);
        //If something goes wrong, retry after 30s
        setTimeout(() => {
          getServiceNowOperationalStatus();
        }, 30000);
      });

    setIsLoading(false);
    return true;
  };

  const updateHTMLExpandable = (parent) => {
    const childrenDetails = parent.children;
    const allElements = [...childrenDetails];
    Array.from(childrenDetails).forEach((child) => {
      allElements.push(...child.children);
    });
    allElements.forEach((element) => {
      element.classList.add('c-service-info__noStyle');
    });
  };

  useEffect(() => {
    getServiceNowOperationalStatus(false);
    const interval = setInterval(() => {
      getServiceNowOperationalStatus(true);
    }, props.Timeout);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setWarningStatuses(
        sessionStorage.getItem('serviceStatus')
          ? JSON.parse(sessionStorage.getItem('serviceStatus')).WarningStatuses
          : []
      );
      setErrorStatuses(
        sessionStorage.getItem('serviceStatus')
          ? JSON.parse(sessionStorage.getItem('serviceStatus')).ErrorStatuses
          : []
      );
    }, 10);
  }, [statuses]);

  useEffect(() => {
    if (allparentRefErrror.length !== 0) {
      allparentRefErrror.forEach((ref) => {
        if (ref.current !== null) {
          updateHTMLExpandable(ref.current);
        }
      });
    }
    if (allparentRefWarning.length !== 0) {
      allparentRefWarning.forEach((ref) => {
        if (ref.current !== null) {
          updateHTMLExpandable(ref.current);
        }
      });
    }
    setIsLoading(false);
  }, [openedErrorExpandable, openedWarningExpandable, isLoading]);

  const formatDate = (date) => {
    if (!date) return null;
    const dateString = new Date(date).toISOString();
    return dateString.split('T')[0];
  };

  const formatTime = (date) => {
    if (!date) return null;
    return new Date(date).toLocaleTimeString('sv-SE').slice(0, 5);
  };

  const toggleExpandable = (id, sessionType, setType, typeOpend) => {
    const newState = {
      ...typeOpend,
      [id]: !typeOpend[id],
    };
    setType(newState);
    sessionStorage.setItem(sessionType, JSON.stringify(newState));
  };

  const ErrorCards = () => {
    return errorStatuses.map((item, index) => {
      const parentRefErrror = useRef(null);
      const lastUpdated = (
        <div className="c-service-info__lastUpdated">
          <p className="c-service-info__noStyle">
            Startdatum: <strong>{formatDate(item.Date)}</strong>
            <time>{` | ${formatTime(item.Date)}`}</time>
          </p>
        </div>
      );

      const status = (
        <p className="c-service-info__noStyle">
          Status: <strong>{item.StatusName}</strong>
        </p>
      );

      const detailsHtml = (
        <div
          ref={parentRefErrror}
          className="c-service-info__noStyle"
          dangerouslySetInnerHTML={{ __html: item.Details }}
        ></div>
      );
      allparentRefErrror.push(parentRefErrror);
      return (
        <IDSExpandableAlert
          statusName={item.StatusName}
          key={index}
          icon={<ErrorAlert />}
          type={'error'}
          title={item.Name}
          details={detailsHtml}
          status={status}
          lastUpdated={lastUpdated}
          opened={openedErrorExpandable[index]}
          setOpened={() => {
            toggleExpandable(
              index,
              'openedErrorExpandables',
              setOpenedErrorExpandable,
              openedErrorExpandable
            );
          }}
          isExpandable
          index
        />
      );
    });
  };

  const WarningCards = () => {
    return warningStatuses.map((item, idx) => {
      const parentRefWarning = useRef(null);

      const lastUpdated = (
        <div className="c-service-info__lastUpdated">
          <p className="c-service-info__noStyle">
            Startdatum: <strong>{formatDate(item.Date)}</strong>
            <time>{` | ${formatTime(item.Date)}`}</time>
          </p>
        </div>
      );
      const detailsHtml = (
        <div
          ref={parentRefWarning}
          className="c-service-info__noStyle"
          dangerouslySetInnerHTML={{ __html: item.Details }}
        ></div>
      );
      allparentRefWarning.push(parentRefWarning);

      const status = (
        <p className="c-service-info__noStyle">
          Status: <strong>{item.StatusName}</strong>
        </p>
      );
      return (
        <IDSExpandableAlert
          statusName={item.StatusName}
          key={idx}
          icon={<AttentionAlert />}
          type={'attention'}
          title={item.Name}
          details={detailsHtml}
          status={status}
          lastUpdated={lastUpdated}
          opened={openedWarningExpandable[idx]}
          setOpened={() => {
            toggleExpandable(
              idx,
              'openedWarningExpandables',
              setOpenedWarningExpandable,
              openedWarningExpandable
            );
          }}
          isExpandable
        />
      );
    });
  };

  const NoErrorsCard = () => {
    return (
      <IDSExpandableAlert
        icon={<SuccessAlert />}
        type={'success'}
        title={props.OkMessage}
        status={Translations.statuslabel}
        variant={'compact'}
      />
    );
  };

  const ServiceInfoCards = () => {
    return serviceMessages.map((serviceItem, index) => {
      const detailsHtml = (
        <div
          className="c-service-info__noStyle"
          dangerouslySetInnerHTML={{ __html: serviceItem.ContentString }}
        ></div>
      );
      return (
        <IDSExpandableAlert
          key={index}
          icon={<InfoAlert />}
          type={'info'}
          title={serviceItem.Heading}
          infoData={detailsHtml}
        />
      );
    });
  };

  if (!allStatuses) {
    return (
      <div className="row">
        <h2
          className="c-service-info__list-header"
          data-cy="inera-current-errors"
        >
          {props.Translations.couldnotload}
        </h2>
      </div>
    );
  }

  let listSize = Math.ceil(allStatuses.length / 3);

  const list1 = {
    list: allStatuses.slice(0, listSize),
  };

  const list2 = {
    list: allStatuses.slice(listSize, listSize * 2),
  };

  const list3 = {
    list: allStatuses.slice(listSize * 2, listSize * 3),
  };

  return (
    <div className="row">
      {allStatuses && allStatuses.length === 0 && !isLoading ? (
        <div>{props.Translations.couldnotload}</div>
      ) : isLoading ? (
        <Spinner Modifiers={{ 'c-spinner--service-info': true }} />
      ) : (
        <>
          <div
            aria-live="assertive"
            className={classNames({
              'c-service-info__card-list columns': true,
              'c-service-info__card-list--1col-grid': true,
            })}
          >
            {errorStatuses.length > 0 && <ErrorCards />}
            {warningStatuses.length > 0 && <WarningCards />}
            {serviceMessages.length > 0 && <ServiceInfoCards />}

            {errorStatuses.length === 0 &&
              warningStatuses.length === 0 &&
              props.OkMessage &&
              allStatuses.length !== 0 && <NoErrorsCard />}
          </div>
          <div className="columns">
            <h3
              className="c-service-info__list-header"
              data-cy="inera-status-heading"
            >
              {props.Translations.statusheading}
            </h3>

            <div
              className="c-service-info c-service-info__list"
              aria-live="assertive"
            >
              <ul>{list1.list && <StatusList {...list1} />}</ul>

              <ul>{list2.list && <StatusList {...list2} />}</ul>

              <ul>{list3.list && <StatusList {...list3} />}</ul>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ServiceInfo;
